import { ApiResponse } from "@avamae/formbuilder/dist/FormBuilder";
import instance from "api";
import { endpoints } from "config";
import { ActionsObservable, ofType } from "redux-observable";
import { from } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { signOut } from "./auth";
import { Store } from "./rootReducer";

/* STATE */
type State = {
  pendingGuaranteesCount: number | null;
};

const initialState: State = {
  pendingGuaranteesCount: null,
};

/* ACTIONS */
const SET_PENDING_GUARANTEES_COUNT = "SET_PENDING_GUARANTEES_COUNT";

type Action = {
  type: typeof SET_PENDING_GUARANTEES_COUNT;
  payload: number | null;
};

// enum EpicActions {
//   UPDATE_USER_INFO = "UPDATE_USER_INFO",
// }
// type EpicAction = {
//   type: EpicActions.UPDATE_USER_INFO;
// };

export default function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case SET_PENDING_GUARANTEES_COUNT:
      return { ...state, pendingGuaranteesCount: action.payload };
    default:
      return state;
  }
}

// type UpdateUserInfoEpicAction = { type: EpicActions.UPDATE_USER_INFO };
// export const updateUserInfoEpic = (
//   action$: ActionsObservable<UpdateUserInfoEpicAction>
// ) =>
//   action$.pipe(
//     ofType(EpicActions.UPDATE_USER_INFO),
//     switchMap(() => {
//       return from(
//         instance.get<ApiResponse<any, UserInformation>>(
//           endpoints.profile.userInfo
//         )
//       ).pipe(
//         map(response => setUserInfo(response.data.details)),
//         catchError(() => {
//           return [
//             signOut("We couldn't get your information, please sign in again"),
//             deleteUserInfo(),
//           ];
//         })
//       );
//     })
//   );

/* Action Creators */
export const setPendingGuaranteesCount = (
  pendingGuaranteesCount: number | null
): Action => {
  return {
    type: SET_PENDING_GUARANTEES_COUNT,
    payload: pendingGuaranteesCount,
  };
};

/* SELECTORS */
export const selectPendingGuaranteesCount = (store: Store) =>
  store.guarantees.pendingGuaranteesCount;
